<template>
  <div
    class="card__media media__video border-radius-zero"
    :style="videoStyle"
  >
    <div
      v-if="video.isFeatured"
      class="media__video__feature"
    >
      {{ $t('video._sidebar.featured') }}
    </div>

    <div class="media__video__play  d-none d-sm-flex">
      <button
        type="button"
        class="vs-btn btn btn--play"
      />
    </div>

    <div
      v-if="video.duration"
      class="media__video__duration  d-none d-sm-flex"
    >
      <i
        class="material-icons"
        data-icon="play_arrow"
      /><span>{{ $t('video._sidebar.duration', { duration: video.duration }) }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { VideoInfoCardCompat } from '@/scripts/models/CardInfoCompat/VideoInfoCardCompat';

export default Vue.extend({
  props: {
    video: {
      type: Object as PropType<VideoInfoCardCompat>,
      required: true,
    },
  },
  computed: {
    videoStyle(): any {
      if (!this.video.imageUrl) return ({});
      return { backgroundImage: `url("${this.video.imageUrl}")` };
    },
  },
});
</script>

<style lang="scss" scoped>
.media__video {
  background-color: rgba(black, 0.10);
  animation-name: loading-media-video-cover;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

$loading-bg-color-high: 0.15;
$loading-bg-color-low: 0.10;
@keyframes loading-media-video-cover {
  0% { background-color: rgba(black, $loading-bg-color-high); }
  50% { background-color: rgba(black, $loading-bg-color-low); }
  100% { background-color: rgba(black, $loading-bg-color-high); }
}
</style>
